import {Http} from '@angular/http';
import {Observable} from "rxjs/Observable";
import {AccountsPerIpInterface} from "./api.models";
import {Request} from "../../../../request.abstract";
import {Settings} from "../../../../settings.model";

export class ReceiversEndpoint extends Request {
    protected baseId: number;

    constructor(http: Http, settings: Settings, baseId: number) {
        super(http, settings);
        this.baseId = baseId;
    }

    accountsPerIp(): Observable<AccountsPerIpInterface[]> {
        return this.get('/v1/bases/' + this.baseId + '/proxy/v1/statistics/receivers/accounts-per-ip');
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/bases/proxy/statistics/receivers/api.service.ts